import React from 'react';

export const WelcomeMessage: React.FC<
  {
    classNames: Record<string, string>;
  } & { welcomeMessageRef: any }
> = ({ classNames, welcomeMessageRef }) => (
  <div className={classNames.welcomeContainer} ref={welcomeMessageRef}>
    <h1 className={classNames.welcome}>
      <span className="welcome">Welcome </span>
      <span className="welcome">to </span>
      <span className="welcome">my </span>
      <span className="welcome">Portfolio</span>
    </h1>
  </div>
);
